export const customModalStyles = {
  content: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    height: '100%',
    inset: 0,
    width: '100%',
  },
  overlay: { zIndex: 1000 },
};
